"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _vueI18n = _interopRequireDefault(require("vue-i18n"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _en = _interopRequireDefault(require("element-ui/lib/locale/lang/en"));
var _zhTW = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-TW"));
var _en2 = _interopRequireDefault(require("./en"));
var _zh = _interopRequireDefault(require("./zh"));
// element-ui lang
// element-ui lang

_vue.default.use(_vueI18n.default);
const messages = {
  en: {
    ..._en2.default,
    ..._en.default
  },
  zh: {
    ..._zh.default,
    ..._zhTW.default
  }
};
const i18n = new _vueI18n.default({
  locale: _jsCookie.default.get('language') || 'en',
  messages
});
var _default = exports.default = i18n;